// Google Analytics (GA4) helpers.
//
// gtag.js is loaded in index.html. These helpers no-op when it hasn't loaded
// (ad blockers, local dev without network), so callers never need to check.

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

// Same key is read by the inline script in index.html before the first
// gtag('config') call, so the initial page_view is tagged too. Visiting any
// page with ?internal=1 sets it (use this on your own devices); ?internal=0
// clears it.
const INTERNAL_KEY = 'wa_internal_traffic';

export function isInternalTraffic(): boolean {
  try {
    return localStorage.getItem(INTERNAL_KEY) === '1';
  } catch {
    return false;
  }
}

// Marks this browser as internal (our own staff/testing) so GA4's
// "Internal Traffic" data filter excludes it. Called for super_admin sessions.
export function markInternalTraffic(): void {
  try {
    localStorage.setItem(INTERNAL_KEY, '1');
  } catch {
    // Storage unavailable (private mode etc.): fall through to the gtag set.
  }
  window.gtag?.('set', { traffic_type: 'internal' });
}

// Adds traffic_type to an event's parameters when this browser is internal.
export function withTrafficType(params: Record<string, unknown> = {}): Record<string, unknown> {
  return isInternalTraffic() ? { ...params, traffic_type: 'internal' } : params;
}

// Sends a GA4 event. Never pass personal data (names, emails, pupil details).
export function trackEvent(name: string, params: Record<string, unknown> = {}): void {
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', name, withTrafficType(params));
}
